export default __webpack_public_path__ + "static/media/c-icon.ff6cb4bd.svg";